import { EnumInputItem } from '../../types/enums';

export type ReportsAgingWindowItemType = EnumInputItem<{
  from: number;
  to: number;
}>;

export const ReportsAgingWindowData = {
  under30: {
    value: 1,
    key: 'under30',
    label: '< 30 days',
    from: 0,
    to: 30
  },
  days31To60: {
    value: 2,
    key: 'days31To60',
    label: '31-60 days',
    from: 31,
    to: 60
  },
  days61To90: {
    value: 3,
    key: 'days61To90',
    label: '61-90 days',
    from: 61,
    to: 90
  },
  days91To180: {
    value: 4,
    key: 'days91To180',
    label: '91-180 days',
    from: 91,
    to: 180
  },
  over181: {
    value: 7,
    key: 'over181',
    label: '> 181 days',
    from: 181,
    to: Number.MAX_SAFE_INTEGER
  }
};
export type ReportsAgingWindowDataType = typeof ReportsAgingWindowData;
export type ReportsAgingWindowKeyType = ReportsAgingWindowItemType['key'];
